var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00B0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.81 9.026C29.54 8.659 23.155.049 15 .049S.458 8.659.19 9.025c-.253.348-.253.82 0 1.168.268.366 6.654 8.977 14.81 8.977s14.541-8.61 14.81-8.977c.253-.348.253-.82 0-1.167zM15 17.192c-6.008 0-11.21-5.715-12.751-7.583 1.538-1.87 6.73-7.582 12.75-7.582 6.008 0 11.21 5.714 12.752 7.583-1.538 1.87-6.73 7.582-12.751 7.582z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.675c-3.272 0-5.934 2.662-5.934 5.934 0 3.272 2.662 5.934 5.934 5.934 3.272 0 5.934-2.662 5.934-5.934 0-3.272-2.662-5.934-5.934-5.934zm0 9.89c-2.182 0-3.956-1.774-3.956-3.956 0-2.181 1.774-3.956 3.956-3.956 2.181 0 3.956 1.775 3.956 3.956 0 2.182-1.775 3.956-3.956 3.956z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.60ecc7078f243dbcf39dd988425f4c59.svg";
export { ForwardRef as ReactComponent };